import React, { useEffect, useState } from "react";
import {
  company_icon,
  email_icon,
  eye_icon,
  knf_logo,
  knfLogo,
  logo,
  mobile_icon,
  password_icon,
} from "../../assets/imgs";
import { useNavigate, useParams } from "react-router-dom";
import apiRequest from "../redux/api/apiRequest";
import { toast } from "react-toastify";
import {
  useChangePasswordMutation,
  useLazyVerifyTokenQuery,
} from "../redux/api/api";
import {
  PASS,
  validateConfirmPassword,
  validatePassword,
} from "../redux/api/Constants";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [verified, setVerified] = useState(false);
  const [err, setErr] = useState(false);
  const [loader, setLoader] = useState(false);
  const [visible, setVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [isPassFocused, setIsPassFocused] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [passwordConError, setPasswordConError] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [verifyToken] = useLazyVerifyTokenQuery();
  const [changePassword] = useChangePasswordMutation();
  const { token } = useParams();

  const passwordRules = [
    {
      label: "At least 8 characters",
      test: (v) => v.length >= 8,
    },
    {
      label: "One uppercase letter",
      test: (v) => /[A-Z]/.test(v),
    },
    {
      label: "One lowercase letter",
      test: (v) => /[a-z]/.test(v),
    },
    {
      label: "One number",
      test: (v) => /[0-9]/.test(v),
    },
    {
      label: "One special character (!*@#%&()^~{})",
      test: (v) => /[!*@#%&()^~{}]/.test(v),
    },
  ];

  const checkToken = async (tok) => {
    const res = await apiRequest(verifyToken, tok);
    if (res?.status == "success") {
      setEmail(res?.v_token?.email);
    } else {
      navigate("/");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };

  useEffect(() => {
    if (token) {
      checkToken(token);
    }
  }, []);

  const resetPassword = async () => {
    if (!email) {
      return;
    }

    if (
      confirmPassword.length < 8 ||
      password.length < 8 ||
      !password.match(PASS) ||
      password != confirmPassword
    ) {
      setErr(true);
      return;
    }

    const formdata = new FormData();
    formdata.append("token", token);
    formdata.append("password", password);
    formdata.append("password_confirmation", confirmPassword);
    setErr(false);
    setLoader(true);
    const res = await apiRequest(changePassword, formdata);
    setLoader(false);
    if (res?.status == "success") {
      toast.success(res?.message);
      navigate("/");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
    console.log(res);
  };
  return (
    <>
      <div className="knf_login_page">
        <div className="main-wrapper">
          {/* LEFT SIDE */}
          <div className="login-left">
            <img
              src={knfLogo} // your single image
              className="glass-image"
              alt="company"
            />
          </div>

          {/* RIGHT SIDE */}
          <div className="login-right">
            <div className="login-box">
              <h2 className="mt-4">Reset Password</h2>

              <div className="text-start">
                <p className="mt-4 f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
                  Email
                </p>
                <div className="login-input mt-2">
                  <MailOutlineRoundedIcon className="emial-icon" />
                  <input
                    type="email"
                    name="Email"
                    placeholder="Email Address"
                    value={email}
                    disabled={true}
                  />
                </div>
              </div>

              <div className="text-start">
                <p className="mt-4 f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
                  Password
                </p>
                <div className="login-input mt-2">
                  <LockOutlinedIcon className="emial-icon" />
                  <input
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setPasswordError(""); // LIVE VALIDATION
                      const error = validatePassword(e.target.value);
                      setPasswordError(error);
                    }}
                    type={visible ? "text" : "password"}
                    onFocus={() => setIsPassFocused(true)}
                    onBlur={() => setIsPassFocused(false)}
                    maxLength={20}
                    placeholder="Password"
                  />
                  {visible ? (
                    <VisibilityIcon
                      className="eye-icon pointer"
                      onClick={() => setVisible(false)}
                    />
                  ) : (
                    <img
                      src={eye_icon}
                      className="eye-icon pointer"
                      onClick={() => setVisible(true)}
                    />
                  )}
                </div>
                {err && password?.length == 0 && (
                  <p className="err" style={{ marginTop: "2%" }}>
                    Please enter a Password
                  </p>
                )}
                {isPassFocused && (
                  <div className="login_pass">
                    <div className="password-rules">
                      {passwordRules.map((rule, index) => {
                        const passed = rule.test(password || "");
                        return (
                          <p
                            key={index}
                            className={`rule ${passed ? "success" : "error"}`}
                          >
                            {passed ? "✔" : "✖"} {rule.label}
                          </p>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              <div className="text-start">
                <p className="mt-4 f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
                  Confirm Password
                </p>
                <div className="login-input mt-2">
                  <LockOutlinedIcon className="emial-icon" />
                  <input
                    value={confirmPassword}
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                      const error = validateConfirmPassword(
                        password,
                        e.target.value,
                      );
                      setPasswordConError(error);
                    }}
                    type={visible ? "text" : "password"}
                    maxLength={20}
                    placeholder="Confirm Password"
                  />
                  {!visible && (
                    <img
                      src={eye_icon}
                      onClick={() => setVisible(!visible)}
                      className="eye-icon pointer mb-1"
                      alt=""
                    />
                  )}
                  {visible && (
                    <div
                      onClick={() => setVisible(!visible)}
                      className="pointer sec"
                    >
                      <VisibilityIcon className="eye-icon " />
                    </div>
                  )}
                </div>
                {err && confirmPassword?.length == 0 && (
                  <p className="err" style={{ marginTop: "2%" }}>
                    Please enter a Confirm Password
                  </p>
                )}
                {confirmPassword?.length > 0 && passwordConError && (
                  <p className="err" style={{ marginTop: "2%" }}>
                    {passwordConError}
                  </p>
                )}
                {/* {err &&
              (!confirmPassword ||
                confirmPassword != password ||
                confirmPassword.length < 8) && (
                <p className="err" style={{ color: "white", marginTop: "2%" }}>
                  {!confirmPassword
                    ? "Enter Confirm Password"
                    : confirmPassword.length < 8
                      ? "Enter Minimum 8 Characters"
                      : "Password Mismatch"}
                </p>
              )} */}
              </div>

              <button
                disabled={loader}
                onClick={() => {
                  resetPassword();
                }}
                className="login-btn-knf f2"
              >
                {loader ? (
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                    style={{ marginRight: "5px" }}
                  ></div>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
